import { type GridColDef } from "@mui/x-data-grid";
import moment from "moment";

import { OrgDoc } from "api/memberPortal/orgs/orgs.types";
import { DOCUMENT_TYPE_MAP } from "common/constants/documentTypes";
import { dataGridDateOnlyGetter } from "components/MUI/DataGrid/DataGrid.utils";

import SerialNumberActionCell from "./cells/SerialNumberTable.actions";

interface SerialNumberTableColumnsProps {
  setShowEditModal: (_show: boolean) => void;
  setDocument: (_document: OrgDoc) => void;
  setShowDeleteModal: (_show: boolean) => void;
}

const SerialNumberTableColumns = ({
  setShowEditModal,
  setDocument,
  setShowDeleteModal,
}: SerialNumberTableColumnsProps): GridColDef<OrgDoc>[] => [
  {
    headerName: "Serial Number",
    field: "fullsn",
    flex: 1,
  },
  {
    headerName: "Document Type",
    field: "pcode",
    flex: 2,
    align: "center",
    headerAlign: "center",
    valueGetter: (value: string) => DOCUMENT_TYPE_MAP[value] ?? value,
  },
  {
    headerName: "VID",
    field: "pid",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    headerName: "Dated",
    field: "dtd",
    valueGetter: dataGridDateOnlyGetter,
    valueFormatter: (value) =>
      value ? moment.utc(value).format("MM/DD/YYYY") : "Pending",
    flex: 1,
  },
  {
    headerName: "Generated",
    field: "entrydate",
    valueGetter: dataGridDateOnlyGetter,
    valueFormatter: (value) =>
      value ? moment.utc(value).format("MM/DD/YYYY") : "Pending",
    flex: 1,
  },
  {
    headerName: "Actions",
    field: "actions",
    sortable: false,
    renderCell: ({ row }) => (
      <SerialNumberActionCell
        document={row}
        setShowEditModal={setShowEditModal}
        setDocument={setDocument}
        setShowDeleteModal={setShowDeleteModal}
      />
    ),
    flex: 2,
    align: "right",
    headerAlign: "center",
  },
];

export default SerialNumberTableColumns;
